import React from 'react';
import { compose, withHandlers } from 'recompose';
import { reduxForm, Field } from 'redux-form';
import Button from '@material-ui/core/Button';
import withStyles from '@material-ui/core/styles/withStyles';
import { Select } from 'redux-form-material-ui';
import Grid from '@material-ui/core/Grid';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import { withRouter } from 'react-router-dom';
import { get } from 'lodash';

const styles = (theme) => ({});

const enhance = compose(
  withStyles(styles),
  withRouter,
  withHandlers({}),
  reduxForm({ form: 'editProductAttributeForm' })
);

export default enhance(
  ({ classes, handleSubmit, setEditUserInfo, attributes, category, history }) => (
    <form className={classes.form} onSubmit={handleSubmit}>
      <Grid container spacing={8}>
        {category &&
          category.map((item, i) => (
            <Grid key={item.id} item xs={12}>
              <FormControl style={{ minWidth: 200 }}>
                <InputLabel htmlFor={item.name}>{item.name}</InputLabel>
                <Field name={`attributes.${item.id}`} component={Select} placeholder={item.name}>
                  {get(item, 'valueTypes', []).includes('int') &&
                  get(item, 'valueTypes', []).length === 1
                    ? item.values
                        .sort((a, b) => parseInt(a.value, 10) - parseInt(b.value, 10))
                        .map((item2) => (
                          <MenuItem key={item2.id} value={item2.id}>
                            {item2.value}
                          </MenuItem>
                        ))
                    : item.values
                        .sort((a, b) => (a.value > b.value) - (a.value < b.value))
                        .map((item2) => (
                          <MenuItem key={item2.id} value={item2.id}>
                            {item2.value}
                          </MenuItem>
                        ))}
                </Field>
              </FormControl>
            </Grid>
          ))}
      </Grid>
      <div style={{ marginTop: 20 }}>
        <Button type="submit" variant="contained" color="primary" className={classes.submit}>
          Uložit
        </Button>
        <Button variant="contained" color="secondary" onClick={() => history.push('/products')}>
          Zrušit
        </Button>
      </div>
    </form>
  )
);



// WEBPACK FOOTER //
// ./src/modules/products/form/attributeForm.js